import React from 'react'

const ContentBoxBody = ({ children }) => {
    return (<div className="content-box-body">{children}</div>)
}

export default ContentBoxBody



// WEBPACK FOOTER //
// ./src/modules/layout/component/ContentBoxBody.js